<script>
  import { createEventDispatcher, onMount, afterUpdate } from 'svelte';
  import { fade } from 'svelte/transition';
  import Button from '../Button.svelte';
  import Spinner from '../Spinner.svelte';

  const dispatch = createEventDispatcher();

  export let title = 'Dialog';
  export let open = false;
  export let placeholder = '';
  export let inputValue = '';

  let inputEl;

  $: open && inputEl && inputEl.focus();

  export let isLoading = false;

  afterUpdate(() => {
    if (inputEl) {
      inputEl.focus();
    }
  });

  const onOkClicked = () => {
    dispatch('ok', inputValue);
    inputValue = '';
  };

  const onCancelClicked = () => {
    dispatch('cancel');
    inputValue = '';
  };

  const handleKeydown = (e) => {
    if (document.activeElement === inputEl) {
      // Enter
      if (e.keyCode === 13 && inputValue.length) {
        onOkClicked();
      } else if (e.keyCode === 27) {
        onCancelClicked();
      }
    }
  };
</script>

<svelte:window on:keydown={handleKeydown} />

<div class="dialog-container" class:open={open === true} on:mousedown={onCancelClicked} in:fade>
  <div class="main" on:mousedown={(e) => e.stopPropagation()} in:fade>
    <div class="header">
      <h3>{title}</h3>
      <div class="btn-container">
        <span class="material-icons" on:click={onCancelClicked}> close </span>
      </div>
    </div>
    <div class="content">
      {#if $$slots.content}
        <slot name="content" />
      {:else if isLoading}
        <Spinner />
      {:else}
        <input bind:value={inputValue} {placeholder} bind:this={inputEl} />
        <div class="btn-container">
          <Button on:click={() => dispatch('cancel')} class="cancel-button" secondary>
            Avbryt
          </Button>
          <Button class="confirm-button" on:click={onOkClicked} disabled={inputValue.length === 0}>
            Ok
          </Button>
        </div>
      {/if}
    </div>
  </div>
</div>

<style src="./dialog.scss">
</style>
